var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeOpenRedesign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7188 21.291C19.4802 21.291 21.7188 19.0524 21.7188 16.291C21.7188 13.5296 19.4802 11.291 16.7188 11.291C13.9573 11.291 11.7188 13.5296 11.7188 16.291C11.7188 19.0524 13.9573 21.291 16.7188 21.291Z",
    fill: "#AFBDD7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.71875 16.291C2.71875 16.291 8.71875 24.291 16.7188 24.291C24.7188 24.291 30.7188 16.291 30.7188 16.291",
    stroke: "#AFBDD7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.71875 16.291C2.71875 16.291 8.71875 8.29102 16.7188 8.29102C24.7188 8.29102 30.7188 16.291 30.7188 16.291",
    stroke: "#AFBDD7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOpenRedesign);
export default __webpack_public_path__ + "static/media/eyeOpenRedesign.fc662c32d5c2a7b3823e9cf7489b3b8d.svg";
export { ForwardRef as ReactComponent };